"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValuePropTypes = exports.ValidFilesPropTypes = exports.SharedFieldPropTypes = exports.SharedDefaultProps = exports.RadioPropTypes = exports.InheritedRadioPropTypes = exports.InheritedFormFieldPropTypes = exports.InheritedCheckboxPropTypes = exports.FormFieldPropTypes = exports.FormFieldDefaultProps = exports.FileUploadPropTypes = exports.FileUploadLabelStyleButtonPropTypes = exports.FieldLabelTextPropTypes = exports.DropdownPropTypes = exports.DatePropTypes = exports.CheckboxPropTypes = exports.AutoCompletePropTypes = void 0;
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _validationPropType = require("./validationPropType");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const FieldLabelTextPropTypes = exports.FieldLabelTextPropTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
  labelId: _propTypes.default.string,
  inputId: _propTypes.default.string,
  hideLabel: _propTypes.default.bool,
  labelTooltip: _propTypes.default.node,
  srInstruction: _propTypes.default.string
};
const ValuePropTypes = exports.ValuePropTypes = [_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.shape({
  label: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
}), _propTypes.default.element];
const SharedFieldPropTypes = exports.SharedFieldPropTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: _propTypes.default.any,
  name: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
  labelId: _propTypes.default.string,
  hideLabel: _propTypes.default.bool,
  srInstruction: _propTypes.default.string,
  labelIsInset: _propTypes.default.bool,
  defaultValue: _propTypes.default.oneOfType(ValuePropTypes),
  validation: _propTypes.default.shape(_validationPropType.ValidationPropType),
  customCssClass: _propTypes.default.string,
  labelCustomCssClass: _propTypes.default.string,
  inputCustomCssClass: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  customChangeHandler: _propTypes.default.func,
  customKeyHandler: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string),
  customPreInputContent: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  customPostInputContent: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  crossFieldValidator: _propTypes.default.shape({
    fieldsToWatch: _propTypes.default.arrayOf(_propTypes.default.string),
    validators: _propTypes.default.objectOf(_propTypes.default.func)
  }),
  deps: _propTypes.default.arrayOf(_propTypes.default.string)
};
const FormFieldPropTypes = exports.FormFieldPropTypes = _objectSpread(_objectSpread({}, SharedFieldPropTypes), {}, {
  placeholder: _propTypes.default.string,
  inputType: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType(ValuePropTypes),
  showSpinner: _propTypes.default.bool,
  labelTooltip: _propTypes.default.node
});
const InheritedFormFieldPropTypes = exports.InheritedFormFieldPropTypes = _objectSpread(_objectSpread({}, FormFieldPropTypes), {}, {
  name: _propTypes.default.string
});
const SharedDefaultProps = exports.SharedDefaultProps = {
  customCssClass: '',
  labelCustomCssClass: '',
  inputCustomCssClass: '',
  customPreInputContent: null,
  customPostInputContent: null
};
const FormFieldDefaultProps = exports.FormFieldDefaultProps = _objectSpread(_objectSpread({}, SharedDefaultProps), {}, {
  inputType: 'text'
});
const AutoCompletePropTypes = exports.AutoCompletePropTypes = _objectSpread(_objectSpread({}, FormFieldPropTypes), {}, {
  minCharacters: _propTypes.default.number,
  srInstruction: _propTypes.default.string,
  ResultMarkup: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  onSearch: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  onSelectWithData: _propTypes.default.func,
  searchResults: _propTypes.default.arrayOf(_propTypes.default.any),
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string),
  resultMarkupValueKey: _propTypes.default.string
});
const CheckboxPropTypes = exports.CheckboxPropTypes = _objectSpread(_objectSpread({}, SharedFieldPropTypes), {}, {
  customChangeHandler: _propTypes.default.func
});
const InheritedCheckboxPropTypes = exports.InheritedCheckboxPropTypes = _objectSpread(_objectSpread({}, CheckboxPropTypes), {}, {
  name: _propTypes.default.string
});
const RadioPropTypes = exports.RadioPropTypes = _objectSpread(_objectSpread({}, SharedFieldPropTypes), {}, {
  customChangeHandler: _propTypes.default.func
});
const InheritedRadioPropTypes = exports.InheritedRadioPropTypes = _objectSpread(_objectSpread({}, RadioPropTypes), {}, {
  name: _propTypes.default.string
});
const DropdownPropTypes = exports.DropdownPropTypes = _objectSpread(_objectSpread({}, SharedFieldPropTypes), {}, {
  includeEmptyOption: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType(ValuePropTypes)
  }), _propTypes.default.string, _propTypes.default.number]))
});
const ValidFilesPropTypes = exports.ValidFilesPropTypes = _propTypes.default.shape({
  extensions: _propTypes.default.arrayOf(_propTypes.default.string),
  maxFileCount: _propTypes.default.number,
  maxFileSize: _propTypes.default.number
});
const FileUploadLabelStyleButtonPropTypes = exports.FileUploadLabelStyleButtonPropTypes = {
  buttonCssClass: _propTypes.default.string,
  maxFileCount: _propTypes.default.number,
  maxFileSize: _propTypes.default.string,
  restrictionsTxt: _propTypes.default.string,
  onClick: _propTypes.default.func
};
const FileUploadPropTypes = exports.FileUploadPropTypes = _objectSpread(_objectSpread({}, FormFieldPropTypes), {}, {
  labelStyle: _propTypes.default.oneOf(['default', 'button']),
  listStyle: _propTypes.default.oneOf(['default', 'reveal']),
  labelStyleButtonProps: _propTypes.default.shape({
    FileUploadLabelStyleButtonPropTypes
  }),
  customFileUploadLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  validFiles: ValidFilesPropTypes
});
const DatePropTypes = exports.DatePropTypes = _objectSpread(_objectSpread({}, FormFieldPropTypes), {}, {
  dateFormat: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  timeFormat: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  initialValue: _propTypes.default.string,
  initialViewDate: _propTypes.default.string
});